import React, { useEffect, useState } from 'react'
import { Card, Steps, Tooltip, Collapse,Select } from "antd";
import ReactLoading from "react-loading";
import axios from 'axios'
import Dashboard from "../../layouts/Dashboard";
import moment from "moment";
import { Pagination } from "antd";
import { message } from "antd";
import BASE from "../../config"
import {changeDateAndTimeFormat} from "../../utils/commonFunctions"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const { Option } = Select;

function TrfProcess() {
    const [load,setLoad] = useState(false)
    const [trfs,setTrfs] = useState([])
    const [process,setProcess] = useState([])
    const [location,setLocation] = useState([])
    const [current, setCurrent] = useState(1);
    const [data,setData] = useState({
        loc:"",
        process:""
    })
    const onChange = (page) => {
        setCurrent(page);
    };


    const getAllProcesses = async (e) =>{
        setLoad(true);
        const config = {
          url: BASE.api + '/processes',
          method:'get',
          headers: { 
            'Content-Type': 'application/json', 
            'Authorization': `Bearer ${localStorage.getItem('user.token')}`
          },
        }
        try {
          const response = await axios(config);        
          if (response.data.processes.length > 0) {
            setProcess(response.data.processes)
          } else {
            setProcess([])
            message.warning("No Process Available", 2);
          }
          setLoad(false);
        } catch (e) {
          setLoad(false);
        }     
    }

    const getAllLocation = async (e) =>{
        setLoad(true);
        const config = {
          url: BASE.api + '/location',
          method:'get',
          headers: { 
            'Content-Type': 'application/json', 
            'Authorization': `Bearer ${localStorage.getItem('user.token')}`
          },
        }
        try {
          const response = await axios(config);  
          if (response.data.locationMaster.length > 0) {
            setLocation(response.data.locationMaster)
          } else {
            setLocation([])
            message.warning("No Location Available", 2);
          }
          setLoad(false);
        } catch (e) {
          setLoad(false);
        }     
    }
    
    const generateTinData = async () =>{
      if(data.loc ==='' || data.process === ''){
        message.warning("Please select Process and Location", 2);
        return
      }
        setLoad(true);
        const config = {
          url: BASE.api + '/trfBasedProcess',
          method:'post',
          headers: { 
            'Content-Type': 'application/json', 
            'Authorization': `Bearer ${localStorage.getItem('user.token')}`
          },
          data:{
            processId : data.process,
            locationName : data.loc,
            status : true
          }
        }
        try {
          const response = await axios(config);  
          message.success(response.data.message, 2);
          getTinData()
        } catch (e) {
          setLoad(false);
        }   
    }

    const deleteTrf = async (_id) =>{
      setLoad(true);
      const config = {
        url: BASE.api + `/TRFBasedProcess`,
        method:'put',
        headers: { 
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${localStorage.getItem('user.token')}`
        },
        data:{
          id:_id,
          status:false
        }
      }
      try {
        const response = await axios(config);
        message.success("Deleted Tin Based Process Successfully", 2);
        getTinData()
      } catch (e) {
        setLoad(false);
      }        
    }


    async function getTinData() {
        setLoad(true);
          const config = {
            url: BASE.api + `/trfBasedProcess`,
            method:'get',
            headers: { 
              'Content-Type': 'application/json', 
              'Authorization': `Bearer ${localStorage.getItem('user.token')}`
            },
          }
          try {
            const response = await axios(config);  
            if(response.data.TRFBasedProcessList.length > 0){
              setTrfs([...response.data.TRFBasedProcessList])
            }else{
              setTrfs([])
            }
            setLoad(false);
          } catch (e) {
            setLoad(false);
          }        
      }


    useEffect(() => {
        getAllProcesses()
        getAllLocation()
        getTinData()
    },[])

    function onChangeProcess(value) {
        setData({
            ...data,
            process:value
        })
    }

    function onChangeLocation(value) {
        setData({
            ...data,
            loc:value
        })
    }

  return (
    <>
      <Dashboard title="TRF Process">
      {
        load && 
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" /> 
      }
        <div className='row'>
            <div className='col-12'>
                <Card title="Filters" className="border mt-3">
                    <div className='row align-items-end'>
                        <div className="col-md-5">
                            <label>Select Process</label>
                            <Select 
                                showSearch
                                style={{width:'100%',height:'37px'}}
                                placeholder="Select Process"
                                optionFilterProp="children"
                                filterOption={(input, option) =>  {
                                    return (option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0)
                                }}
                                onChange={onChangeProcess}
                            >
                                {
                                    process?.map(pro => (
                                        pro.name && 
                                        <Option value={pro._id}>{pro.name}</Option>

                                    ))
                                }
                            </Select>
                        </div>
                        <div className="col-md-5">
                            <label>Select Location</label>
                            <Select 
                                showSearch
                                style={{width:'100%',height:'37px'}}
                                placeholder="Select Location"
                                optionFilterProp="children"
                                filterOption={(input, option) =>  {
                                    return (option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0)
                                }}
                                onChange={onChangeLocation}
                            >
                                {
                                    location?.map(loc => (
                                        loc.locationName && 
                                        <Option value={loc.locationName}>{loc.locationName}</Option>

                                    ))
                                }
                            </Select>
                        </div>
                        <div className="col-md-2">
                            <button
                                className={`btn ${true ? "btn-primary" : "btn-secondary"}`}
                                type="submit"
                                onClick={generateTinData}
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </Card>
            </div>
                <div className='col-12'>
                    <Card className='mt-4' style={{width:'100%'}}>
                        <table className="table bg-white ">
                            <thead>
                            <tr>
                                <th>S No.</th>
                                <th>Process Name</th>
                                <th>Location</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                                {
                                    trfs?.length !== 0 ? <>
                                        {trfs?.map((ele,index) => {
                                            return (
                                            <tr>
                                                <td>{index+1}</td>
                                                <td>{ele.processId.name}</td>
                                                <td>{ele.locationName}</td>
                                                <td>
                                                  <button
                                                    className="btn btn-danger btn-sm mr-1"
                                                    onClick={() => deleteTrf(ele._id)}
                                                  >
                                                    <i class="fa fa-trash" aria-hidden="true"></i>{" "}
                                                    Delete
                                                  </button>
                                                </td>
                                            </tr>
                                            );
                                        })}
                                    </> : <>
                                        <td colSpan={4} style={{textAlign:'center',padding:'3rem'}}>No Data Found</td>
                                    </>
                                }
                            </tbody>
                        </table>
                        <Pagination
                            showSizeChanger = {false}
                            current={current}
                            onChange={onChange}
                            total={trfs?.length}
                        />
                    </Card>
                </div>
                <div>

                </div>
        </div>
    </Dashboard>
    </>
  )
}

export default TrfProcess